"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _loading = require("@/mixins/loading/loading");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRPlanHeaderComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRPlanHeaderComponent, _Mixins);

  var _super = _createSuper(MRPlanHeaderComponent);

  function MRPlanHeaderComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRPlanHeaderComponent);
    _this = _super.apply(this, arguments);
    _this.selectedPlanId = null;
    _this.dateRange = null;
    _this.oldDateRange = null;
    _this.weekNum = null;
    _this.oldWeekNum = null;
    _this.monthRange = null;
    _this.oldMonthRange = null;
    _this.viewType = 'daily';
    _this.oldViewType = 'daily';
    _this.maxDays = 30;
    return _this;
  }

  (0, _createClass2.default)(MRPlanHeaderComponent, [{
    key: "onDateRangeChanges",
    value: function () {
      var _onDateRangeChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newVal, oldVal) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isValidDateRange(newVal)) {
                  this.oldDateRange = oldVal;
                } else {
                  this.dateRange = oldVal;
                }
                /*let isValidDRange = true;
                     if (this.planViewType === 'daily' || this.planViewType === 'weekly') {
                  isValidDRange = this.isValidDateRange(newVal);
                }
                     if (!isValidDRange) {
                  this.dateRange = oldVal;
                } else {
                  // For update order table
                  this.$setDateRange({ startDate: newVal[0] + ' 00:00:00', endDate: newVal[1] + ' 23:59:59' });
                  const p = {...this.$defaultPagination};
                  p.pageSize = this.$pagination['pageSize'];
                  this.$setPagination(p);
                  this.$setSelectedOrders([]);
                  await this.$getUnassignedOrders();
                       this.oldDateRange = oldVal;
                  this.$emit('onUpdateTimeList', newVal[0], newVal[1]);
                }*/


              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDateRangeChanges(_x, _x2) {
        return _onDateRangeChanges.apply(this, arguments);
      }

      return onDateRangeChanges;
    }()
  }, {
    key: "onWeekNumChanges",
    value: function onWeekNumChanges(newVal, oldVal) {
      this.oldWeekNum = oldVal;
    }
  }, {
    key: "onMonthRangeChanges",
    value: function onMonthRangeChanges(newVal, oldVal) {
      this.oldMonthRange = oldVal;
    }
  }, {
    key: "onViewTypeChanges",
    value: function onViewTypeChanges(newVal, oldVal) {
      this.oldViewType = oldVal;
    }
  }, {
    key: "onSelectedTruckChanges",
    value: function onSelectedTruckChanges() {
      this.selectedPlanId = 'newPlanId';
    }
  }, {
    key: "isAssignToTruckDisabled",
    get: function get() {
      return this.$selectedOrders.length === 0 || this.$selectedTruck === null || this.selectedPlanId === null;
    }
  }, {
    key: "getAssignTruckDisabledDetails",
    get: function get() {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false
      };

      if (this.selectedPlanId === null) {
        reason.reason1 = true;
      }

      if (this.$selectedOrders.length === 0) {
        reason.reason2 = true;
      }

      if (this.$selectedTruck === null) {
        reason.reason3 = true;
      }

      return reason;
    }
  }, {
    key: "isDeletePlanDisabled",
    get: function get() {
      if (!(this.$plan && this.$plan.trucks)) {
        return false;
      }

      return this.currPlanTruck && this.currPlanTruck['routes'].some(function (route) {
        if (route.status === 'completed') {
          return true;
        }
      });
    }
  }, {
    key: "checkIfTruckHasRoutes",
    get: function get() {
      var _this2 = this;

      if (this.$selectedTruck) {
        var selectedOrderId = this.helper.get(this.helper.find(this.$plan.trucks, function (truck) {
          return truck['truckId'] === _this2.$selectedTruck;
        }), 'orderId', []);
        return selectedOrderId.length >= 1;
      } else {
        return false;
      }
    }
  }, {
    key: "created",
    value: function created() {
      // Day
      if (this.defaultStartDate && this.defaultEndDate) {
        this.dateRange = [this.defaultStartDate, this.defaultEndDate];
        this.oldDateRange = [this.defaultStartDate, this.defaultEndDate];
      } else {
        this.setMRDateRange();
      } // Week


      this.weekNum = (0, _moment.default)().day(1); // Month

      var today = new Date();
      var startDate = (0, _moment.default)(new Date(today.getFullYear(), today.getMonth(), 1));
      var endDate = (0, _moment.default)(new Date(today.getFullYear(), today.getMonth() + 1, 0));
      this.monthRange = [startDate, endDate];
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.viewType = this.planViewType;
    }
  }, {
    key: "assignToTruck",
    value: function assignToTruck() {
      this.$emit('onManualAssignTruck', this.selectedPlanId);

      var p = _objectSpread(_objectSpread({}, this.$pagination), {}, {
        currentPage: 1
      });

      this.$setPagination(p);
      this.selectedPlanId = 'newPlanId';
    }
  }, {
    key: "isValidDateRange",
    value: function isValidDateRange(dateRange) {
      var startDate = (0, _moment.default)(dateRange[0]);
      var endDate = (0, _moment.default)(dateRange[1]);

      var duration = _moment.default.duration(endDate.diff(startDate)).asDays();

      if (duration > this.maxDays) {
        var message = {
          title: this.$i18n.t('general.queryExceed1Month'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        return false;
      }

      return true;
    }
  }, {
    key: "handleDateRangeChanges",
    value: function () {
      var _handleDateRangeChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(newVal) {
        var _this3 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.$anyChanges) {
                  _context3.next = 5;
                  break;
                }

                message = this.$i18n.t('planning.messages.unsavedChanges');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _this3.oldDateRange = newVal;

                          _this3.$emit('onUpdateTimeList', newVal[0], newVal[1]);

                          _this3.resetLocalVariable();

                          _this3.$planDateRange = _this3.dateRange;
                          _this3.$anyChanges = false;
                          _context2.next = 7;
                          return _this3.refreshOrderTable(newVal);

                        case 7:
                          _context2.next = 9;
                          return _this3.refreshPlan();

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }))).catch(function () {
                  _this3.$planDateRange = _this3.oldDateRange;
                  _this3.dateRange = _this3.oldDateRange;
                });

                _context3.next = 12;
                break;

              case 5:
                this.oldDateRange = newVal;
                this.$emit('onUpdateTimeList', newVal[0], newVal[1]);
                this.$planDateRange = this.dateRange;
                _context3.next = 10;
                return this.refreshOrderTable(newVal);

              case 10:
                _context3.next = 12;
                return this.refreshPlan();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleDateRangeChanges(_x3) {
        return _handleDateRangeChanges.apply(this, arguments);
      }

      return handleDateRangeChanges;
    }()
  }, {
    key: "handleWeekChanges",
    value: function () {
      var _handleWeekChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(newVal) {
        var _this4 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.$anyChanges) {
                  _context5.next = 5;
                  break;
                }

                message = this.$i18n.t('planning.messages.unsavedChanges');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!_this4.isWeekChanged()) {
                            _context4.next = 5;
                            break;
                          }

                          _this4.resetLocalVariable();

                          _this4.$anyChanges = false;
                          _context4.next = 5;
                          return _this4.refreshPlan();

                        case 5:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }))).catch(function () {
                  _this4.$planDateRange = _this4.oldDateRange;
                  _this4.dateRange = _this4.oldDateRange;
                  _this4.weekNum = _this4.oldWeekNum;
                });

                _context5.next = 8;
                break;

              case 5:
                if (!this.isWeekChanged()) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return this.refreshPlan();

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleWeekChanges(_x4) {
        return _handleWeekChanges.apply(this, arguments);
      }

      return handleWeekChanges;
    }()
  }, {
    key: "isWeekChanged",
    value: function isWeekChanged() {
      var el = this.helper.get(this.$refs, 'week', null);

      if (this.helper.isUndefined(el)) {
        return false;
      }

      var weekNum = parseInt(el.displayValue.split(' ')[1], 10);
      var startDate = (0, _moment.default)().isoWeek(weekNum || 1).startOf('week');
      var endDate = (0, _moment.default)().isoWeek(weekNum || 1).startOf('week').add(7, 'day');
      this.dateRange = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
      return true;
    }
  }, {
    key: "handleMonthChanges",
    value: function () {
      var _handleMonthChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(newVal) {
        var _this5 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.$anyChanges) {
                  _context7.next = 5;
                  break;
                }

                message = this.$i18n.t('planning.messages.unsavedChanges');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!_this5.isMonthChanged(newVal)) {
                            _context6.next = 5;
                            break;
                          }

                          _this5.resetLocalVariable();

                          _this5.$anyChanges = false;
                          _context6.next = 5;
                          return _this5.refreshPlan();

                        case 5:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }))).catch(function () {
                  _this5.$planDateRange = _this5.oldDateRange;
                  _this5.dateRange = _this5.oldDateRange;
                  _this5.monthRange = _this5.oldMonthRange;
                });

                _context7.next = 8;
                break;

              case 5:
                if (!this.isWeekChanged()) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return this.refreshPlan();

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handleMonthChanges(_x5) {
        return _handleMonthChanges.apply(this, arguments);
      }

      return handleMonthChanges;
    }()
  }, {
    key: "isMonthChanged",
    value: function isMonthChanged(newVal) {
      var el = this.helper.get(this.$refs, 'month', null);

      if (this.helper.isUndefined(el)) {
        return false;
      }

      var startDate = (0, _moment.default)(newVal[0]);
      var endDate = (0, _moment.default)(newVal[1]);
      this.dateRange = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
      return true;
    }
  }, {
    key: "refreshPlan",
    value: function () {
      var _refreshPlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.$truckLoading = true;
                _context8.next = 3;
                return this.$resetPlan();

              case 3:
                _context8.next = 5;
                return this.$initPlan();

              case 5:
                _context8.next = 7;
                return this.$getUnassignedOrders();

              case 7:
                this.$truckLoading = false;

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function refreshPlan() {
        return _refreshPlan.apply(this, arguments);
      }

      return refreshPlan;
    }()
  }, {
    key: "handleViewTypeChanges",
    value: function () {
      var _handleViewTypeChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(newVal) {
        var _this6 = this;

        var message;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!this.$anyChanges) {
                  _context10.next = 5;
                  break;
                }

                message = this.$i18n.t('planning.messages.unsavedChanges');

                _elementUi.MessageBox.confirm(message, 'Warning', {
                  confirmButtonText: this.$i18n.t('pickColumns.confirm'),
                  cancelButtonText: this.$i18n.t('pickColumns.cancel'),
                  type: 'warning',
                  center: true
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                  return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          if (!_this6.isViewTypeChanged(newVal)) {
                            _context9.next = 5;
                            break;
                          }

                          _this6.resetLocalVariable();

                          _this6.$anyChanges = false;
                          _context9.next = 5;
                          return _this6.refreshPlan();

                        case 5:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }))).catch(function () {
                  // this.$planDateRange = this.oldDateRange;
                  // this.dateRange = this.oldDateRange;
                  // this.weekNum = this.oldWeekNum;
                  // this.monthRange = this.oldMonthRange;
                  _this6.viewType = _this6.oldViewType;
                });

                _context10.next = 8;
                break;

              case 5:
                if (!this.isViewTypeChanged(newVal)) {
                  _context10.next = 8;
                  break;
                }

                _context10.next = 8;
                return this.refreshPlan();

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function handleViewTypeChanges(_x6) {
        return _handleViewTypeChanges.apply(this, arguments);
      }

      return handleViewTypeChanges;
    }()
  }, {
    key: "isViewTypeChanged",
    value: function isViewTypeChanged(newVal) {
      if (newVal === 'daily') {
        this.$emit('onPlanViewChange', newVal);
        this.setMRDateRange();
        return true;
      }

      if (newVal === 'weekly') {
        this.$emit('onPlanViewChange', newVal);
        this.setWeekNum();
        return true;
      }

      if (newVal === 'monthly') {
        this.$emit('onPlanViewChange', newVal);
        this.setMonthRange();
        return true;
      }

      return false;
    }
  }, {
    key: "setMRDateRange",
    value: function setMRDateRange() {
      var startDate = (0, _moment.default)(new Date());
      var endDate = (0, _moment.default)(new Date()).add(3, 'days');
      this.dateRange = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
      this.weekNum = startDate;
    }
  }, {
    key: "setWeekNum",
    value: function setWeekNum() {
      var startDate = (0, _moment.default)().day(0);
      var endDate = (0, _moment.default)().day(6);
      this.dateRange = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
      this.weekNum = (0, _moment.default)().day(1);
    }
  }, {
    key: "setMonthRange",
    value: function setMonthRange() {
      var today = new Date();
      var startDate = (0, _moment.default)(new Date(today.getFullYear(), today.getMonth(), 1));
      var endDate = (0, _moment.default)(new Date(today.getFullYear(), today.getMonth() + 1, 0));
      this.dateRange = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
      this.monthRange = [startDate, endDate];
    }
  }, {
    key: "resetLocalVariable",
    value: function resetLocalVariable() {
      this.oldDateRange = null;
      this.oldWeekNum = null;
      this.oldMonthRange = null; // this.oldViewType = 'daily';
    }
  }, {
    key: "handleSelectedTruckChanges",
    value: function handleSelectedTruckChanges(truckId) {// Socket for global trucks

      /*this.socketAPI.updateLMDGlobalSelectedTrucks({
        user: this.$userInformation.user.name,
              truckId: truckId ? [truckId] : [],
      });*/
    }
  }, {
    key: "refreshOrderTable",
    value: function () {
      var _refreshOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(newVal) {
        var p;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.$setDateRange({
                  startDate: newVal[0] + ' 00:00:00',
                  endDate: newVal[1] + ' 23:59:59'
                });
                p = _objectSpread({}, this.$defaultPagination);
                p.pageSize = this.$pagination['pageSize'];
                this.$setPagination(p);
                this.$setSelectedOrders([]); // await this.$getUnassignedOrders();

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function refreshOrderTable(_x7) {
        return _refreshOrderTable.apply(this, arguments);
      }

      return refreshOrderTable;
    }()
  }]);
  return MRPlanHeaderComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MRPlanHeaderComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'manual'
})], MRPlanHeaderComponent.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'daily'
})], MRPlanHeaderComponent.prototype, "planViewType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], MRPlanHeaderComponent.prototype, "defaultStartDate", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], MRPlanHeaderComponent.prototype, "defaultEndDate", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('dateRange')], MRPlanHeaderComponent.prototype, "onDateRangeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('weekNum')], MRPlanHeaderComponent.prototype, "onWeekNumChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('monthRange')], MRPlanHeaderComponent.prototype, "onMonthRangeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('viewType')], MRPlanHeaderComponent.prototype, "onViewTypeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedTruck')], MRPlanHeaderComponent.prototype, "onSelectedTruckChanges", null);
MRPlanHeaderComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRPlanHeaderComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-input': _elementUi.Input
  }
})], MRPlanHeaderComponent);
var _default = MRPlanHeaderComponent;
exports.default = _default;